<ul class="app-selector">
  <li>
    <button
      mat-button
      [ngClass]="{ 'is-active': applicationName === 'Work Orders' }"
      (click)="changeApplication('Work Orders')"
    >
      <mat-icon>list_alt</mat-icon>
      <span>{{ "app.selector.work-orders" | translate }}</span>
    </button>
  </li>
  <li>
    <button
      mat-button
      [ngClass]="{ 'is-active': applicationName === 'Hires' }"
      (click)="changeApplication('Hires')"
    >
      <mat-icon class="hires">person_add</mat-icon>
      <span>{{ "app.selector.hires" | translate }}</span>
    </button>
  </li>
  <li>
    <button
      mat-button
      [ngClass]="{ 'is-active': applicationName === 'Leaves' }"
      (click)="changeApplication('Leaves')"
    >
      <mat-icon>transfer_within_a_station</mat-icon>
      <span>{{ "app.selector.leaves" | translate }}</span>
    </button>
  </li>
</ul>
